export const getMaintenanceStatus = ({ maintenance }) => maintenance.ACTIVE;

export const getMaintenanceEstimatedEnd = ({ maintenance }) => maintenance.ESTIMATED_END;
